{
  "REPORT": {
    "HEADER": "Бесіди",
    "LOADING_CHART": "Завантаження даних діаграми...",
    "NO_ENOUGH_DATA": "Ми не отримали достатньо даних для генерації звіту. Будь ласка, спробуйте ще раз пізніше.",
    "DOWNLOAD_AGENT_REPORTS": "Завантажити звіти агентів",
    "DATA_FETCHING_FAILED": "Не вдалося отримати дані. Будь ласка, повторіть спробу пізніше.",
    "SUMMARY_FETCHING_FAILED": "Не вдалося отримати дані. Будь ласка, повторіть спробу пізніше.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Бесіди",
        "DESC": "(Загалом)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Вхідні повідомлення",
        "DESC": "(Загалом)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Вихідні повідомлення",
        "DESC": "(Загалом)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Час першої відповіді",
        "DESC": "( Середнє )",
        "INFO_TEXT": "Загальна кількість бесід, що використовуються для обчислення:",
        "TOOLTIP_TEXT": "Час першої відповіді {metricValue} (на основі {conversationCount} розмов)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Час до вирішення",
        "DESC": "( Середнє )",
        "INFO_TEXT": "Загальна кількість бесід, що використовуються для обчислення:",
        "TOOLTIP_TEXT": "Час рішення {metricValue} (на основі {conversationCount} розмов)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Кількість вирішень",
        "DESC": "(Загалом)"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Кількість вирішень",
        "DESC": "(Загалом)"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "(Загалом)"
      },
      "REPLY_TIME": {
        "NAME": "Час очікування клієнта",
        "TOOLTIP_TEXT": "Час очікування становить {metricValue} (на основі відповідей {conversationCount})",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Сьогодні",
      "YESTERDAY": "Вчора",
      "LAST_7_DAYS": "Останні 7 днів",
      "LAST_30_DAYS": "Останні 30 днів",
      "THIS_MONTH": "Цей місяць",
      "LAST_MONTH": "Минулий місяць",
      "LAST_3_MONTHS": "Останні 3 місяці",
      "LAST_6_MONTHS": "Останні 6 місяців",
      "LAST_YEAR": "Минулий рік",
      "CUSTOM_DATE_RANGE": "Довільний діапазон дат"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Підтвердити",
      "PLACEHOLDER": "Виберіть діапазон дат"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Групувати за",
    "DURATION_FILTER_LABEL": "Тривалість",
    "GROUPING_OPTIONS": {
      "DAY": "День",
      "WEEK": "Тиждень",
      "MONTH": "Місяць",
      "YEAR": "Рік"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "День"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "День"
      },
      {
        "id": 2,
        "groupBy": "Тиждень"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "День"
      },
      {
        "id": 2,
        "groupBy": "Тиждень"
      },
      {
        "id": 3,
        "groupBy": "Місяць"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "День"
      },
      {
        "id": 2,
        "groupBy": "Тиждень"
      },
      {
        "id": 3,
        "groupBy": "Місяць"
      }
    ],
    "BUSINESS_HOURS": "Робочий час",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Очистити фільтр",
      "EMPTY_LIST": "Результатів не знайдено"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Бесіди: {count}",
      "RESULT_COUNT_MESSAGE": "Повідомлення: {count}",
      "EMPTY": "Для цього стовпця записів не знайдено.",
      "ERROR": "Не вдалося завантажити записи. Спробуйте ще раз.",
      "LOAD_MORE": "Завантажити ще",
      "PREVIOUS_BUCKET": "Попередній стовпець",
      "NEXT_BUCKET": "Наступний стовпець",
      "UNKNOWN_CONTACT": "Невідомий контакт",
      "UNKNOWN_INBOX": "Невідомий канал",
      "UNASSIGNED_AGENT": "Не призначено",
      "NO_MESSAGE_CONTENT": "Немає вмісту повідомлення",
      "MESSAGE_CREATED_AT": "Повідомлення створено {time}",
      "EVENT_OCCURRED_AT": "Подія сталася {time}",
      "INCOMING_MESSAGE": "Вхідне повідомлення",
      "OUTGOING_MESSAGE": "Вихідне повідомлення",
      "VIEW_ALL": "Переглянути в бесідах",
      "VIEW_ALL_LIMIT": "У списку бесід відкриваються лише стовпці, у яких не більше {limit} бесід.",
      "HIDDEN_COUNT": "Не показано, бо ви не учасник їхнього каналу: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Огляд Агентів",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Завантаження даних діаграми...",
    "NO_ENOUGH_DATA": "Ми не отримали достатньо даних для генерації звіту. Будь ласка, спробуйте ще раз пізніше.",
    "DOWNLOAD_AGENT_REPORTS": "Завантажити звіти агентів",
    "FILTER_DROPDOWN_LABEL": "Виберіть агента",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Бесіди",
        "DESC": "(Загалом)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Вхідні повідомлення",
        "DESC": "(Загалом)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Вихідні повідомлення",
        "DESC": "(Загалом)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Час першої відповіді",
        "DESC": "( Середнє )",
        "INFO_TEXT": "Загальна кількість бесід, що використовуються для обчислення:",
        "TOOLTIP_TEXT": "Час першої відповіді {metricValue} (на основі {conversationCount} розмов)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Час до вирішення",
        "DESC": "( Середнє )",
        "INFO_TEXT": "Загальна кількість бесід, що використовуються для обчислення:",
        "TOOLTIP_TEXT": "Час рішення {metricValue} (на основі {conversationCount} розмов)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Кількість вирішень",
        "DESC": "(Загалом)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Останні 7 днів"
      },
      {
        "id": 1,
        "name": "Останні 30 днів"
      },
      {
        "id": 2,
        "name": "Останні 3 місяці"
      },
      {
        "id": 3,
        "name": "Останні 6 місяців"
      },
      {
        "id": 4,
        "name": "Минулий рік"
      },
      {
        "id": 5,
        "name": "Довільний діапазон дат"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Підтвердити",
      "PLACEHOLDER": "Виберіть діапазон дат"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Огляд міток",
    "DESCRIPTION": "Відстежуйте ефективність міток за ключовими показниками: розмови, час відповіді, час вирішення та вирішені звернення.",
    "LOADING_CHART": "Завантаження даних діаграми...",
    "NO_ENOUGH_DATA": "Ми не отримали достатньо даних для генерації звіту. Будь ласка, спробуйте ще раз пізніше.",
    "DOWNLOAD_LABEL_REPORTS": "Завантажити звіти по міткам",
    "FILTER_DROPDOWN_LABEL": "Виберіть Мітку",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Бесіди",
        "DESC": "(Загалом)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Вхідні повідомлення",
        "DESC": "(Загалом)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Вихідні повідомлення",
        "DESC": "(Загалом)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Час першої відповіді",
        "DESC": "( Середнє )",
        "INFO_TEXT": "Загальна кількість розмов, що використовуються для обчислень:",
        "TOOLTIP_TEXT": "Час першої відповіді {metricValue} (на основі {conversationCount} розмов)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Час до вирішення",
        "DESC": "( Середнє )",
        "INFO_TEXT": "Загальна кількість бесід, що використовуються для обчислення:",
        "TOOLTIP_TEXT": "Час рішення {metricValue} (на основі {conversationCount} розмов)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Кількість вирішень",
        "DESC": "(Загалом)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Останні 7 днів"
      },
      {
        "id": 1,
        "name": "Останні 30 днів"
      },
      {
        "id": 2,
        "name": "Останні 3 місяці"
      },
      {
        "id": 3,
        "name": "Останні 6 місяців"
      },
      {
        "id": 4,
        "name": "Минулий рік"
      },
      {
        "id": 5,
        "name": "Довільний діапазон дат"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Підтвердити",
      "PLACEHOLDER": "Виберіть діапазон дат"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Огляд вхідних повідомлень",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Завантаження даних діаграми...",
    "NO_ENOUGH_DATA": "Ми не отримали достатньо даних для генерації звіту. Будь ласка, спробуйте ще раз пізніше.",
    "DOWNLOAD_INBOX_REPORTS": "Завантажити звіти вхідних повідомлень",
    "FILTER_DROPDOWN_LABEL": "Вибрати \"Вхідний\" канал",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Бесіди",
        "DESC": "(Загалом)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Вхідні повідомлення",
        "DESC": "(Загалом)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Вихідні повідомлення",
        "DESC": "(Загалом)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Час першої відповіді",
        "DESC": "( Середнє )",
        "INFO_TEXT": "Загальна кількість бесід, що використовуються для обчислення:",
        "TOOLTIP_TEXT": "Час першої відповіді {metricValue} (на основі {conversationCount} розмов)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Час до вирішення",
        "DESC": "( Середнє )",
        "INFO_TEXT": "Загальна кількість бесід, що використовуються для обчислення:",
        "TOOLTIP_TEXT": "Час рішення {metricValue} (на основі {conversationCount} розмов)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Кількість вирішень",
        "DESC": "(Загалом)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Останні 7 днів"
      },
      {
        "id": 1,
        "name": "Останні 30 днів"
      },
      {
        "id": 2,
        "name": "Останні 3 місяці"
      },
      {
        "id": 3,
        "name": "Останні 6 місяців"
      },
      {
        "id": 4,
        "name": "Минулий рік"
      },
      {
        "id": 5,
        "name": "Довільний діапазон дат"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Прийняти",
      "PLACEHOLDER": "Виберіть діапазон дат"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Огляд команди",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Завантаження даних діаграми...",
    "NO_ENOUGH_DATA": "Ми не отримали достатньо даних для генерації звіту. Будь ласка, спробуйте ще раз пізніше.",
    "DOWNLOAD_TEAM_REPORTS": "Завантажити звіти команд",
    "FILTER_DROPDOWN_LABEL": "Оберіть команду",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Бесіди",
        "DESC": "(Загалом)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Вхідні повідомлення",
        "DESC": "(Загалом)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Вихідні повідомлення",
        "DESC": "(Загалом)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Час першої відповіді",
        "DESC": "( Середнє )",
        "INFO_TEXT": "Загальна кількість бесід, що використовуються для обчислення:",
        "TOOLTIP_TEXT": "Час першої відповіді {metricValue} (на основі {conversationCount} розмов)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Час до вирішення",
        "DESC": "( Середнє )",
        "INFO_TEXT": "Загальна кількість бесід, що використовуються для обчислення:",
        "TOOLTIP_TEXT": "Час рішення {metricValue} (на основі {conversationCount} розмов)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Кількість вирішень",
        "DESC": "(Загалом)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Останні 7 днів"
      },
      {
        "id": 1,
        "name": "Останні 30 днів"
      },
      {
        "id": 2,
        "name": "Останні 3 місяці"
      },
      {
        "id": 3,
        "name": "Останні 6 місяців"
      },
      {
        "id": 4,
        "name": "Минулий рік"
      },
      {
        "id": 5,
        "name": "Довільний діапазон дат"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Прийняти",
      "PLACEHOLDER": "Виберіть діапазон дат"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Звіти CSAT",
    "NO_RECORDS": "Немає доступних відповідей для опитувань CSAT.",
    "DOWNLOAD": "Завантажити CSAT звіти",
    "DOWNLOAD_FAILED": "Не вдалося завантажити звіти CSAT",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Виберіть Агентів"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Контакт",
        "AGENT_NAME": "Призначений агент",
        "RATING": "Оцінка",
        "FEEDBACK_TEXT": "Відгук"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Всього відповідей",
        "TOOLTIP": "Загальна кількість зібраних відповідей"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Оцінка задоволеності",
        "TOOLTIP": "Загальна кількість позитивних відповідей / Загальна кількість відповідей * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Показник відповідей",
        "TOOLTIP": "Загальна кількість відповідей / Загальна кількість повідомлень опитування CSAT відправлено * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Звіти з ботів",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "Кількість розмов",
        "TOOLTIP": "Загальна кількість розмов, оброблених ботом"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Всього відповідей",
        "TOOLTIP": "Загальна кількість відповідей, надісланих ботом"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Час вирішення",
        "TOOLTIP": "Загальна кількість розмов, вирішених ботом / Всього кількості розмов, які обробляє бот * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Загальна кількість розмов, переданих агентам / Загальна кількість розмов, яку обробляє бот * 100"
      },
      "CONVERSATION_COUNT": {
        "LABEL": "Кількість розмов",
        "TOOLTIP": "Загальна кількість розмов з повідомленнями бота"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Кількість відповідей",
        "TOOLTIP": "Загальна кількість вихідних повідомлень"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Кількість AI відповідей",
        "TOOLTIP": "Загальна кількість відповідей, надісланих ботом"
      },
      "COPILOT_COUNT": {
        "LABEL": "Кількість підготовлених відповідей",
        "TOOLTIP": "Загальна кількість підказок Copilot, підготовлених ботом для агентів"
      },
      "SUCCESS_RATE": {
        "LABEL": "Вирішено AI",
        "TOOLTIP": "Відсоток розмов, вирішених AI без передачі агенту"
      },
      "RESOLVE_TIME": {
        "LABEL": "Час до вирішення",
        "TOOLTIP": "Медіанний час від першого повідомлення клієнта до останнього повідомлення бота/агента"
      }
    },
    "GROUP_BY": {
      "LABEL": "Групувати за",
      "NONE": "Не групувати",
      "INBOXES": "Вхідні",
      "LABELS": "Мітки"
    },
    "GROUPED": {
      "CHART_TITLE": "Розподіл за групами",
      "BACK_TO_ALL": "Показати всі",
      "TABLE": {
        "INBOX": "Вхідні",
        "LABEL": "Мітка",
        "CONVERSATIONS": "Розмови",
        "MESSAGES": "Повідомлення",
        "MESSAGES_TOOLTIP": "Загальна кількість вихідних повідомлень",
        "AI_MESSAGES": "AI відповіді",
        "AI_MESSAGES_TOOLTIP": "Загальна кількість AI відповідей, після чого йде кількість позитивних і негативних оцінок кінцевих користувачів",
        "THUMBS_UP_TOOLTIP": "Кількість AI відповідей, оцінених позитивно (палець вгору) кінцевими користувачами",
        "THUMBS_DOWN_TOOLTIP": "Кількість AI відповідей, оцінених негативно (палець вниз) кінцевими користувачами",
        "AI_PERCENTAGE": "AI %",
        "AI_PERCENTAGE_TOOLTIP": "Відсоток AI відповідей від усіх повідомлень у цій групі",
        "PREPARED": "Підготовлені відповіді",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Відсоток повідомлень від усіх повідомлень цієї групи",
        "BOT_RESPONSES": "AI відповіді %",
        "SUGGESTION_USED": "Використані відповіді",
        "SUGGESTION_USED_TOOLTIP": "Відсоток підготовлених відповідей у цій групі, які були використані агентами",
        "SUGGESTION_NOT_USED": "Невикористані відповіді",
        "SUGGESTION_NOT_USED_TOOLTIP": "Відсоток повідомлень у цій групі, для яких була підготовлена відповідь, але її не використали"
      },
      "NOTES": {
        "TITLE": "Як розраховуються метрики",
        "CONVERSATIONS": "Кількість розмов, у яких є принаймні одне вихідне повідомлення за вибраний період.",
        "MESSAGES": "Загальна кількість вихідних (не приватних) повідомлень, надісланих за вибраний період. Сюди входять як повідомлення, створені AI, так і написані людиною.",
        "PERCENTAGE": "Частка повідомлень цієї групи від усіх вихідних повідомлень серед усіх груп.",
        "AI_MESSAGES": "Кількість вихідних повідомлень, надісланих автоматично AI-ботом (без урахування підготовлених відповідей для агентів). Числа в дужках показують, скільки з цих відповідей кінцеві користувачі оцінили позитивно (палець вгору) і негативно (палець вниз).",
        "BOT_RESPONSES_PCT": "Частка AI-відповідей цієї групи від усіх вихідних повідомлень цієї групи.",
        "PREPARED": "Кількість підказок Copilot (підготовлених відповідей), згенерованих AI-ботом для агентів за вибраний період. Це приватні повідомлення, видимі лише агентам, і вони не враховуються як вихідні повідомлення, тому це число може не корелювати зі стовпцем Повідомлення.",
        "SUGGESTION_USED": "Відсоток підготовлених відповідей у цій групі, які були використані агентами. Це може не корелювати з кількістю Підготовлених відповідей, оскільки сюди можуть входити підказки, згенеровані в попередніх періодах.",
        "SUGGESTION_NOT_USED": "Відсоток вихідних повідомлень у цій групі, де була доступна підказка Copilot, але агент відповів, не використовуючи її. Враховується лише тоді, коли агент дійсно надіслав відповідь. Це може не корелювати з кількістю Підготовлених відповідей, оскільки сюди можуть входити підказки, згенеровані в попередніх періодах."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Огляд",
    "LIVE": "Онлайн",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Відкрити розмову",
      "LOADING_MESSAGE": "Завантаження метрик розмови...",
      "OPEN": "Відкриті",
      "UNATTENDED": "Не зв'язаний",
      "UNASSIGNED": "Непризначені",
      "PENDING": "Очікує"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Бесіди",
      "NO_CONVERSATIONS": "Немає бесід",
      "CONVERSATION": "{count} бесід",
      "CONVERSATIONS": "{count} бесід",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Розмови агентів",
      "LOADING_MESSAGE": "Завантаження метрик агента...",
      "NO_AGENTS": "Немає розмов, пов'язаних з агентом",
      "TABLE_HEADER": {
        "AGENT": "Агент",
        "OPEN": "Відкриті",
        "UNATTENDED": "Не зв'язаний",
        "STATUS": "Статус"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Команда",
        "OPEN": "Відкриті",
        "UNATTENDED": "Не зв'язаний",
        "STATUS": "Статус"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Статус агента",
      "ONLINE": "Онлайн",
      "BUSY": "Зайнятий",
      "OFFLINE": "Не в мережі"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Неділя",
    "MONDAY": "Понеділок",
    "TUESDAY": "Вівторок",
    "WEDNESDAY": "Середа",
    "THURSDAY": "Четвер",
    "FRIDAY": "П'ятниця",
    "SATURDAY": "Субота"
  },
  "SLA_REPORTS": {
    "HEADER": "Звіти SLA",
    "NO_RECORDS": "SLA розмови недоступні.",
    "LOADING": "Завантаження SLA даних...",
    "DOWNLOAD_SLA_REPORTS": "Завантажити CSAT звіти",
    "DOWNLOAD_FAILED": "Не вдалося завантажити SLA звіти",
    "DROPDOWN": {
      "ADD_FIlTER": "Додати фільтр",
      "CLEAR_ALL": "Очистити все",
      "CLEAR_FILTER": "Очистити фільтр",
      "EMPTY_LIST": "Результатів не знайдено",
      "NO_FILTER": "Немає доступних фільтрів",
      "SEARCH": "Фільтр пошуку",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA назва",
        "AGENTS": "Ім'я агента",
        "INBOXES": "Назва Джерела",
        "LABELS": "Назва мітки",
        "TEAMS": "Назва команди"
      },
      "SLA": "Політика SLA",
      "INBOXES": "Вхідні",
      "AGENTS": "Агент",
      "LABELS": "Мітка",
      "TEAMS": "Команда"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Рейтинг попадань",
        "TOOLTIP": "Відсоток створених SLA був успішно завершений"
      },
      "NO_OF_MISSES": {
        "LABEL": "Кількість промахів",
        "TOOLTIP": "Усього промахів SLA за певний період"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Кількість розмов",
        "TOOLTIP": "Загальна кількість розмов з SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Політика",
        "CONVERSATION": "Діалог",
        "AGENT": "Агент"
      },
      "VIEW_DETAILS": "Переглянути деталі"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Проміжний підсумок",
    "NO_TEAM": "Без команди",
    "GROUP_BY_TEAMS": "Групувати за командами",
    "INBOX": "Вхідні",
    "AGENT": "Агент",
    "TEAM": "Команда",
    "LABEL": "Мітка",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Кількість вирішень",
    "CONVERSATIONS": "№ розмов",
    "TOTAL": "Всього",
    "OUTGOING_CHATS": "Вихідні чати",
    "OUTGOING_EMAILS": "Вихідні email",
    "PHONE_CALLS": "Телефонні дзвінки",
    "INBOUND_CALLS": "Вхідні дзвінки",
    "OUTBOUND_CALLS": "Вихідні дзвінки",
    "TOTAL_ACTIVITIES": "Всього активностей",
    "ONLINE_TIME": "Час онлайн",
    "QUEUE_AVAILABLE_TIME": "Час доступності в черзі",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Кількість вихідних повідомлень, надісланих цим агентом",
      "OUTGOING_EMAILS": "Кількість вихідних email, надісланих цим агентом",
      "PHONE_CALLS": "Загальна кількість телефонних дзвінків, призначених цьому агенту (сума вхідних і вихідних дзвінків)",
      "TOTAL_ACTIVITIES": "Загальна кількість активностей: вхідні дзвінки + вихідні дзвінки + вихідні чати + вихідні email",
      "INBOUND_CALLS": "Кількість вхідних телефонних дзвінків, призначених цьому агенту",
      "OUTBOUND_CALLS": "Кількість вихідних телефонних дзвінків, призначених цьому агенту",
      "AVG_FIRST_RESPONSE_TIME": "Середній час від створення розмови до першої відповіді агента в розмовах, призначених цьому агенту",
      "AVG_RESOLUTION_TIME": "Середній час від створення розмови до її вирішення в розмовах, призначених цьому агенту",
      "AVG_REPLY_TIME": "Середній час, який клієнти очікують між своїм повідомленням і відповіддю агента в розмовах, призначених цьому агенту",
      "ONLINE_TIME": "Загальний час, протягом якого агент був онлайн або зайнятий за вибраний період",
      "QUEUE_AVAILABLE_TIME": "Загальний час, протягом якого агент був доступний у телефонних чергах за вибраний період"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Звіти з телефонних дзвінків",
    "DESCRIPTION": "Відстежуйте метрики телефонних дзвінків з детальним аналізом вхідних і вихідних дзвінків, згрупованих за агентом або каналом для комплексного аналізу.",
    "AGENT_HEADER": "Звіти з телефонних дзвінків — за агентом",
    "INBOX_HEADER": "Звіти з телефонних дзвінків — за каналом",
    "DOWNLOAD_BUTTON": "Завантажити звіти з телефонних дзвінків",
    "DOWNLOAD_PHONE_REPORTS": "Завантажити звіти з телефонних дзвінків",
    "GROUP_BY": {
      "LABEL": "Групувати за",
      "AGENT": "Агент",
      "INBOX": "Канал"
    },
    "TABLE": {
      "AGENT_NAME": "Ім'я агента",
      "INBOX_NAME": "Назва каналу",
      "TOTAL_CALLS": "Всього",
      "INBOUND_CALLS": "Вхідні",
      "OUTBOUND_CALLS": "Вихідні",
      "FAILED_OUTBOUND_CALLS": "Невдалі вихідні",
      "AVG_AGENT_HANDLED_DURATION": "Середня тривалість",
      "TOTAL_AGENT_HANDLED_DURATION": "Загальна тривалість",
      "AVG_RINGING_TIME": "Середній час дзвінка",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Успішні %",
      "UNIQUE_CALLERS": "Унікальні абоненти",
      "UNIQUE_CALLED_CONTACTS": "Унікальні викликані",
      "UNANSWERED_MISSED_CALLS": "Пропущені без зворотного дзвінка",
      "UNANSWERED_MISSED_PERCENTAGE": "Пропущені без відповіді %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Пропущені без зворотного дзвінка, недостатньо передзвонено",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Пропущені без зворотного дзвінка, недостатньо передзвонено %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Загальна кількість усіх дзвінків (включно з нез'єднаними)",
      "INBOUND_CALLS": "Кількість з'єднаних дзвінків",
      "OUTBOUND_CALLS": "Кількість усіх вихідних дзвінків (включно з нез'єднаними)",
      "FAILED_OUTBOUND_CALLS": "Кількість вихідних дзвінків, які не вдалося з'єднати",
      "AVG_AGENT_HANDLED_DURATION": "Середня тривалість дзвінків, оброблених агентами",
      "TOTAL_AGENT_HANDLED_DURATION": "Загальна тривалість усіх дзвінків, оброблених агентами",
      "AVG_RINGING_TIME": "Середній час, протягом якого дзвінки дзвонили перед відповіддю",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Відсоток вихідних дзвінків, які були успішно з'єднані",
      "UNIQUE_CALLERS": "Кількість унікальних контактів, які здійснювали вхідні дзвінки",
      "UNIQUE_CALLED_CONTACTS": "Кількість унікальних контактів, яким телефонували вихідними дзвінками",
      "UNANSWERED_MISSED_CALLS": "Кількість пропущених дзвінків, де не було успішного зворотного дзвінка (з'єднання). Може включати дзвінки, які ще можуть бути оброблені протягом робочого дня",
      "UNANSWERED_MISSED_PERCENTAGE": "Відсоток унікальних абонентів, чиї дзвінки були пропущені без зворотного дзвінка (пропущені без відповіді / унікальні абоненти)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Кількість пропущених дзвінків із менш ніж 2 спробами зворотного дзвінка. Може включати дзвінки, які ще можуть бути оброблені протягом робочого дня",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Відсоток унікальних абонентів із менш ніж 2 спробами зворотного дзвінка ((пропущені без зворотного дзвінка - достатньо оброблені) / унікальні абоненти)"
    },
    "EMPTY_STATE": {
      "TITLE": "Немає даних про телефонні дзвінки",
      "MESSAGE": "У вибраному діапазоні дат немає телефонних дзвінків. Спробуйте змінити фільтри або діапазон дат."
    }
  }
}
